import React from 'react'

import Cards from './Cards'

const Game = () => (
	<div>
		<Cards />
	</div>
)

export default Game
